import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@volca/ui/components/ui/badge";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";
import { roleBadgeVariant, roleLabel } from "@/user/constants";

export const RoleCol = (): ColumnDef<AccountTableUser> => ({
  header: "Role",
  accessorFn: (row) => roleLabel(row.role),
  cell: ({ row }) => {
    const role = row.original.role;
    const label = roleLabel(role);
    const color = roleBadgeVariant(role);

    return (
      <Badge
        variant="secondary"
        color={color}
        className="max-w-full whitespace-normal"
      >
        {label}
      </Badge>
    );
  },
  size: 100,
});
